// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import DragableSvg from '@rsuite/icon-font/lib/action/Dragable';
var Dragable = createSvgIcon({
  as: DragableSvg,
  ariaLabel: 'dragable',
  category: 'action',
  displayName: 'Dragable'
});
export default Dragable;